<template>
  <div class="client-item-box new-time-box" :id="'nofixNav'+data.nofixNavId+'-'+data.nofixNavIndex" v-if="actionTime || data.showImage==='SHOW'" :data-trackdata="tData">
    <beast-image
      class="time-image"
      :image="data.bgImage"
      :lazy="true"
      :containerWidth="containerWidth"
    />
    <div class="time" :style="renderPositionStyl" v-if="actionTime">
      <span class="title-block mr" :style="renderTitleStyl">{{title}}</span>
      <span class="time-block" :style="renderTimeStyl" v-if="actionTime.day != '0'" v-for="item in actionTime.day">{{item}}</span>
      <span v-if="actionTime.day.length && actionTime.day != '0'" class="title-block mr ml" :style="{color: data.titleColor}">天</span>
      <span class="time-block" :style="renderTimeStyl" v-for="(item, index) in actionTime.hour" :class="{'two': index===1}">{{item}}</span>
      <span class="title-block mr ml" :style="renderTitleStyl">时</span>
      <span class="time-block" :style="renderTimeStyl" v-for="(item, index) in actionTime.minute" :class="{'two': index===1}">{{item}}</span>
      <span class="title-block mr ml" :style="renderTitleStyl">分</span>
      <span class="time-block" :style="renderTimeStyl" v-for="(item, index) in actionTime.second" :class="{'two': index===1}">{{item}}</span>
      <span class="title-block ml" :style="renderTitleStyl">秒</span>
    </div>
  </div>
</template>

<script>

import { getCountDown, getClientWidth } from '../lib/util.js'

import beastImage from '@/components/image'

const clientWidth = getClientWidth()
let _rush_count_down = null

export default {
  name: 'article-time',
  props: ['data'],
  data () {
    console.log(this.data, "time data")
    return {
      title: null,
      showTime: null,
      // showFlag: false,
      actionTime: null,
      showImage: true,
      containerWidth: clientWidth,
      ratio: clientWidth/375,
      tData: JSON.stringify(this.data.trackData || {})
    }
  },
  mounted () {
  },
  components: {
    beastImage
  },
  computed: {
    renderPositionStyl () {
      return {
        'left': `${Number(this.data.positionX*this.ratio)}px`,
        'top': `${Number(this.data.positionY*this.ratio)}px`
      }
    },

    renderTitleStyl () {
      return {
        'color': `${this.data.titleColor}`,
        'fontSize': `${Number(this.data.titleSize*this.ratio)}px`
      }
    },

    renderTimeStyl () {
      return {
        'color': `${this.data.timeColor}`,
        'fontSize': `${Number(this.data.timeSize*this.ratio)}px`
      }
    }
  },
  created() {
    this.checkTime()
  },
  methods: {
    checkTime () {
      let time1Str = this.data.time1
      let time2Str = this.data.time2
      let startTimeShow = this.data.startTimeShow
      let endTimeShow = this.data.endTimeShow
      if(!time1Str && !time2Str) {
        return
      }
      let curTime = new Date().getTime()
      let time1 = this.getTime(time1Str)
      let time2 = this.getTime(time2Str)
      console.log(curTime, time1, time2)
      if(startTimeShow !== 'HIDE' && time1 && (curTime < time1)) {
        this.checkTimeCount({
          time1: time1,
          time2: time2,
          curTimeStr: "time1"
        })
      } else if(endTimeShow !== 'HIDE' && time2 && (curTime < time2)) {
        this.checkTimeCount({
          time1: null,
          time2: time2,
          curTimeStr: "time2"
        })
      }

      // this.showFlag = true
    },
    checkTimeCount ({time1, time2, curTimeStr}) {
      // console.log(time1, time2)
      let timeObj = null
      if(curTimeStr === "time1") {
        this.title = this.data.title1
        timeObj = getCountDown(time1)
      }
      if(curTimeStr === "time2") {
        this.title = this.data.title2
        timeObj = getCountDown(time2)
      }
      // console.log(timeObj, "timeObj")
      if(!timeObj) {
        return
      }
      const {
        day,
        hour,
        minute,
        second
      } = timeObj

      if (hour == 0 && minute == 0 && second == 0) {
        this.actionTime = null
        clearTimeout(_rush_count_down)

        if(curTimeStr === "time1" && time2) {
          let curTime = new Date().getTime()
          if(curTime < time2) {
            this.checkTimeCount({
              time1: null,
              time2: time2,
              curTimeStr: "time2"
            })
          } 
          // else {
          //   this.showFlag = false
          // }
        } 
        // else {
        //   this.showFlag = false
        // }
        // return false
      } else {
        // this.actionTime = `${this.addZero(hour)}小时${this.addZero(minute)}分${this.addZero(second)}秒`
        this.actionTime = {
          day: this.formatDateArr(day, false),
          hour: this.formatDateArr(hour),
          minute: this.formatDateArr(minute),
          second: this.formatDateArr(second)
        }
        // console.log(this.actionTime, "actionTime")
        _rush_count_down = setTimeout(() => {
          this.checkTimeCount({
            time1: time1,
            time2: time2,
            curTimeStr: curTimeStr
          })
        }, 1000);
      }
    },
    getTime (time) {
      if (!time) {
        return 0
      }
      let date = new Date(time.replace(/\s/, 'T'))
      // let date = new Date(time.replace(/-/g,'/'))
      // console.log(date, "getTime date")
      return date.getTime()
    },
    formatDateArr (date, isAddZero=true) {
      date += ""
      if(date && date.length > 0) {
        let dateStr = isAddZero?this.addZero(date):(date+"")
        return dateStr.split("")
      } else {
        return []
      }
    },
    addZero (time) {
      if(time < 10) {
        return `0${time}`
      } else {
        return time
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// new-time.vue?578c7614